<script lang="ts" setup>
const { loadLayout, layoutData } = useLayout()
await loadLayout()
</script>

<template>
  <div class="checkout-top">
    <div class="checkout-top__container">
      <AppUsps
        v-if="layoutData?.checkoutHeaderUsps?.[0]?.Usp?.length"
        class="checkout-top__usps"
        :usps="layoutData.checkoutHeaderUsps[0]"
        horizontal
      />
    </div>
  </div>
</template>

<style>
@import url("~layers/components/Checkout/Top.css");
</style>
